import { ResourceType } from '../enums';
import { format } from 'date-fns';

export interface DealResource {
  id: string;
  type: ResourceType.Deal;
  attributes: DealAttributes;
}

export interface DealAttributes {
  [key: string]: number | string | Date | string[] | undefined;
  id: number;
  companyName: string;
  primaryTag: string;
  ecosystemName: string;
  articleUrl: string;
  shortUrl?: string;
  leadInvestors: string;
  investors: string;
  roundType: string;
  date: string;
  amount: number;
  year: string;
  quarter: string;
  brief: string;
  articleTitle?: string;
  articleDescription?: string;
  articleImageUrl?: string;
  articleTags?: string;
  articleSiteName?: string;
}

/**
 * @description Returns a Deal Resource with minimum number of properties set.
 * @function
 * @return {DealResource}
 */
export function defaultDealResource(): DealResource {
  return {
    type: ResourceType.Deal,
    id: '',
    attributes: {
      id: 0,
      companyName: '',
      primaryTag: '',
      ecosystemName: '',
      articleUrl: '',
      shortUrl: '',
      leadInvestors: '',
      investors: '',
      roundType: '',
      date: format(new Date(), 'yyyy-MM-dd'),
      amount: 0,
      year: '',
      quarter: '',
      brief: '',
      articleTitle: '',
      articleDescription: '',
      articleImageUrl: '',
      articleTags: '',
      articleSiteName: '',
    },
  };
}
